const COMPANY_USER_ROLES = [
  {
    id: 1,
    name: "admin",
    display_name: "admin",
  },
  {
    id: 2,
    name: "owner",
    display_name: "project_owner",
  },
  {
    id: 3,
    name: "manager",
    display_name: "manager",
  },
  {
    id: 4,
    name: "form_admin",
    display_name: "form_admin",
  },
  {
    id: 5,
    name: "form_user",
    display_name: "form_user",
  },
  {
    id: 6,
    name: "viewer",
    display_name: "viewer",
  },
];

export default COMPANY_USER_ROLES;
